class AccordionGroup extends HTMLElement {
  connectedCallback() {
    // Wait a moment for child elements to be fully rendered
    setTimeout(() => {
      this.init();
    }, 100);
  }

  init() {
    // Try multiple possible selectors
    const detailsElements = this.querySelectorAll('details, .details, [class*="details"]');
    
    detailsElements.forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.hasAttribute('open') || details.open) {
          this.closeOthers(details);
        }
      });
    });
  }

  closeOthers(currentDetails) {
    const allDetails = this.querySelectorAll('details, .details, [class*="details"]');
    
    allDetails.forEach(details => {
      if (details !== currentDetails) {
        if (details.tagName === 'DETAILS') {
          details.open = false;
        } else if (details.hasAttribute('open')) {
          details.removeAttribute('open');
        } else if (details.classList.contains('is-open') || details.classList.contains('open')) {
          details.classList.remove('is-open', 'open');
        }
      }
    });
  }
}

customElements.define('accordion-group', AccordionGroup);